import { Box, Title } from "@mantine/core";

import { Decimal } from "prisma/cm/client/runtime/library";
import { formatRange } from "utils/utils";

import { useStyles } from "./mantine-extended/use-styles";

export const rangeLabelWidth = {
  base: 107,
  sm: 180,
};

export function RangeLabel({
  rangeLow,
  rangeHigh,
}: {
  rangeLow?: number | Decimal | null;
  rangeHigh?: number | Decimal | null;
}) {
  const { classes } = useStyles();

  function wrapInLabelBox(text: string) {
    return (
      <Box
        bg="gray.2"
        h={{ base: 32, sm: 42 }}
        w={rangeLabelWidth}
        ml={{ base: 8, sm: 24 }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "40px",
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: rangeLabelWidth.base,
          "@media (min-width: var(--mantine-breakpoint-sm))": {
            flexBasis: rangeLabelWidth.sm,
          },
        }}
      >
        <Title order={6} c="gray.8" fz={{ base: 12, sm: 14 }}>
          {text}
        </Title>
      </Box>
    );
  }

  // mounting both to the dom to try and quiet "server/client hydration mismatch"
  return (
    <>
      <Box className={classes.hideLargerThanSm}>
        {wrapInLabelBox(formatRange(rangeLow, rangeHigh, { round: true }))}
      </Box>
      <Box className={classes.hideSmallerThanSm}>
        {wrapInLabelBox(formatRange(rangeLow, rangeHigh, { round: false }))}
      </Box>
    </>
  );
}
